/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import Form from 'src/components/Form';
import { get, has } from 'lodash';
import { DateTime } from 'src_common/utils/time/time';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    CustomerSettingsDiv,
    ContactPreferencesContainer,
    ContactPreferences,
    ContactPreferencesHeader,
    CustomerSettingsButton,
    SuccessMessage,
    ErrorMessage,
    SelectWithPadding,
} from 'src/components/CustomersBar/CustomerTab/CustomerSettingsTab/CustomerSettingsForm/CustomerSettingsForm.style';
import DateInput from 'src/components/DateInput/DateInput.jsx';
import { getTranslationFor } from 'src/locale/lang';
import addError from 'src/utils/error.jsx';
import confirmation from 'src/utils/confirm.jsx';
import { apiManualTriggerRequest } from 'src/api_openapi/v2/idMission/apiManualTrigger';
import { apiVerifyProgressRequest } from 'src/api_openapi/v2/idMission/apiVerifyProgress';
import { apiVerificationsRequest } from 'src/api_openapi/v2/idMission/apiVerifications';
import { apiCancelTriggerRequest } from 'src/api_openapi/v2/idMission/apiCancelTrigger';
import { IdentityVerificationVariantType } from 'src/api_openapi/v2/idMission/schemas';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { Common, useCommon } from 'src/AppState/Common';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { ReactivateSelfExclusionStore } from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/ReactivateSelfExclusion/ReactivateSelfExclusion.store';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { IndependentTooltip } from 'src/components/Tooltip/IndependentTooltip';

type IdMissionStatusType = IdentityVerificationVariantType | null | '';

enum IdMissionResponseType {
    NONE = 'none',
    TRIGGER_SUCCESS = 'trigger-success',
    TRIGGER_ERROR = 'trigger-error',
    CANCEL_SUCCESS = 'cancel-success',
    CANCEL_ERROR = 'cancel-error',
}

interface FormFieldType<T = string | number | boolean | null> {
    readOnly: boolean;
    hidden: boolean;
    value: T;
    optional?: boolean;
}

interface UserDataType {
    id: number;
    name?: string;

    addressLine1?: FormFieldType<string | null>;
    addressLine2?: FormFieldType<string | null>;
    ageVerification?: FormFieldType<string>;
    bankAccountNumber?: FormFieldType<string | null>;
    bankAccountSortCode?: FormFieldType<string | null>;
    birthDate?: FormFieldType<string>;
    city?: FormFieldType<string>;
    closureReasonId?: FormFieldType<number | null>;
    country?: FormFieldType<string>;
    county?: FormFieldType<string | null>;
    creditAccount?: FormFieldType<boolean>;
    creditLimit?: FormFieldType<number>;
    creditPaymentTerms?: FormFieldType<string>;
    currency?: FormFieldType<string>;
    email?: FormFieldType<string>;
    failedLoginAttempts?: FormFieldType<number>;
    firstName?: FormFieldType<string>;
    incomeaccess?: FormFieldType<string>;
    isHVC?: FormFieldType<boolean>;
    kycStatus?: FormFieldType<string>;
    kycWatchlist?: FormFieldType<any>; //type needs to be defined
    landlinePhone?: FormFieldType<any>; //type needs to be defined
    mobilePhone?: FormFieldType<any>; //type needs to be defined
    postCode?: FormFieldType<string>;
    printedStatement?: FormFieldType<boolean>;
    promoBanned?: FormFieldType<boolean>;
    promoID?: FormFieldType<string>;
    quickBetReferralEnabled?: FormFieldType<boolean>;
    ringFencedFunds?: FormFieldType<boolean>;
    securityNotes?: FormFieldType<string | null>;
    statementFrequency?: FormFieldType<string>;
    status?: FormFieldType<string>;
    surname?: FormFieldType<string>;
    telebettingId?: FormFieldType<string | null>;
    telebettingPassword?: FormFieldType<string | null>;
    title?: FormFieldType<string>;
    tradingNotes?: FormFieldType<string | null>;

    affiliate?: any; //type needs to be defined
    amlRisk?: string;
    bankingConfig?: {
        provider: string;
        siteReference: string;
        wsUsername: string;
    };
    betReferralEnabled?: boolean;
    bogLimit?: number | null;
    bpEnabled?: boolean;
    cancelWithdrawal?: boolean;
    cashoutEnabled?: boolean;
    chatEnabled?: boolean;
    commission?: boolean;
    complianceRestriction?: any; //type needs to be defined
    contactPreferences?: string[];
    contactPreferencesByCategory?: Array<{ type: string; categories: string[] }>;
    coolingOffPeriodHours?: number | null;
    countryClub?: any; //type needs to be defined
    createdDate?: any; //type needs to be defined
    depositLimits?: {
        url: string;
        limits: any[]; //type needs to be defined
    };
    dragonCircle?: boolean;
    externalId?: any; //type needs to be defined
    gamStopVerification?: string;
    hasCasino?: any; //type needs to be defined
    hasSpreads?: any; //type needs to be defined
    isArbitrage?: any; //type needs to be defined
    isFastFinger?: any; //type needs to be defined
    isIndustry?: any; //type needs to be defined
    isSPOnly?: any; //type needs to be defined
    kycRequestDate?: any; //type needs to be defined
    language?: string | null;
    marketingQuestionsAnswers?: any; //type needs to be defined
    nextReviewDate?: any; //type needs to be defined
    oddsFormat?: string;
    openBets?: number;
    passwordResetToken?: {
        attempts: number;
        sentVia: string;
        sourceIp: string;
        token: string;
        validFrom: number;
        validTo: number;
    } | null;
    pep?: boolean;
    permissionGrants?: any; //type needs to be defined
    personalId?: any; //type needs to be defined
    playBreakDuration?: any; //type needs to be defined
    playBreakExpiry?: string | null;
    playBreakRequestDate?: any; //type needs to be defined
    reactivationRequestedDate?: any; //type needs to be defined
    realityCheck?: {
        active?: any; //type needs to be defined
        pending?: any; //type needs to be defined
    };
    realityCheckFrequency?: number;
    reviewNetLosses?: number | string | null;
    reviewTotalDeposits?: number | string | null;
    rewardZone?: any; //type needs to be defined
    roles?: any[]; //type needs to be defined
    sanctions?: boolean;
    savedPaymentMethods?: any[]; //type needs to be defined
    selfExclusionDate?: any; //type needs to be defined
    selfExclusionDuration?: any; //type needs to be defined
    selfExclusionExpiry?: string | null;
    spOnlySports?: any[]; //type needs to be defined
    srgStatus?: string;
    srgPrevStatus?: string;
    pofStatus?: string;
    pofPrevStatus?: string;
    prevReviewNetLosses?: number;
    prevReviewTotalDeposits?: number;
    stakeFactor?: number;
    stakeFactorInPlay?: number;
    stakeFactorInPlaySports?: any[]; //type needs to be defined
    stakeFactorSports?: any[]; //type needs to be defined
    tartanClub?: any; //type needs to be defined
    wallet?: {
        creditLimit: number;
        operatorAccumulatedProfit: number;
        profit: number;
        universe: string;
        operatorProfit: number;
        [key: string]: any;
    };
    watchlist?: boolean;
}

interface ErrorsObjectType {
    [key: string]: any;
    get?: (key: string) => string;
}

interface CustomerSettingsFormStateType {
    disabled: any;
    data: UserDataType;
    errors: ErrorsObjectType;
    success: any;
    affordabilityStatus: string;
    affordabilityPrevStatus: string;
    affordabilityChecked: boolean;
    affordabilityManualCheckMessage: boolean | null;
    idMissionStatus: IdMissionStatusType;
    previousIdMissionStatus: IdMissionStatusType;
    initialIdMissionStatus: IdMissionStatusType;
    idMissionActionResponse: IdMissionResponseType;
    passwordTokenCopied: boolean;
}

interface CustomerSettingsFormPropsType {
    common: Common;
    data: UserDataType;
    errors: ErrorsObjectType;
    onSubmit: (e: React.FormEvent) => void;
    openSportsStakes: () => void;
    stakesCount: {
        prematch: number;
        inplay: number;
    };
    universe: string; //todo: ensure its simple type
    languages: any; // todo: type this properly
    sdkStaff: SdkStaff;
    isAffordability: boolean;
    pofFlag: boolean;
    isSrg: boolean;
    idMission: boolean;
    ringFencedFunds: boolean;
    sourceOfFunds: boolean;
    currencies: string[]; //todo: ensure its simple type
    contactPreferences: {
        newMarketing: boolean;
        preferences: string[]; //todo: ensure its simple type
        options: string[]; //todo: ensure its simple type
    };
    accountTradingTartanClub: boolean;
    accountTradingRewardZone: boolean;
    accountTradingDragonCircle: boolean;
    accountTradingCountryClub: boolean;
    closureCodes: boolean;
    isPEP: boolean;
    newPofSrg: boolean;
}

const hasExpired = (date: string | null | undefined): boolean => {
    if (date === null || date === undefined) {
        return true;
    }

    const parsedDate = DateTime.from(date);
    const now = DateTime.current();

    if (parsedDate === null) {
        return true;
    }

    return !parsedDate.isAfter(now);
};

class CustomerSettingsFormInner extends Form {
    declare public state: CustomerSettingsFormStateType;
    declare public props: CustomerSettingsFormPropsType;

    private sdkStaff: SdkStaff;
    private trpcClient: TrpcClient;

    public static fieldsValidation = {
        statementFrequency: ['required'],
        creditLimit: ['required', 'decimal'],
        kycStatus: ['canBeEmpty'],
        currency: ['canBeEmpty'],
        language: ['canBeEmpty'],
        status: ['canBeEmpty'],
        creditPaymentTerms: ['canBeEmpty'],
        tradingNotes: [['canBeEmpty']],
        securityNotes: [['canBeEmpty']],
        reviewTotalDeposits: ['canBeEmpty', 'numeric'],
        reviewNetLosses: ['canBeEmpty', 'numeric'],
        nextReviewDate: ['canBeEmpty', 'date'],
        promoID: ['canBeEmpty'],
        incomeaccess: ['canBeEmpty'],
        stakeFactorInPlay: ['required', 'decimal', ['maxPrecision', 3]],
        stakeFactor: ['required', 'decimal', ['maxPrecision', 3]],
        bogLimit: [
            'canBeEmpty',
            'decimal',
            (value: string): string | null => {
                const val = parseFloat(value);

                if (!isNaN(val) && val < 1) {
                    return getTranslationFor('ERROR_DECIMAL');
                }

                return null;
            },
        ],
    };

    public constructor(props: CustomerSettingsFormPropsType) {
        super(props);

        this.state = {
            ...this.state,
            affordabilityStatus: 'Unknown',
            affordabilityPrevStatus: 'Unknown',
            affordabilityChecked: true,
            affordabilityManualCheckMessage: null,
            idMissionStatus: null,
            previousIdMissionStatus: null,
            initialIdMissionStatus: null,
            idMissionActionResponse: IdMissionResponseType.NONE,
            passwordTokenCopied: false,
            data: {
                ...this.state.data,
                ...this.parseArrayOptions('contactPreferences', this.props),
                ...this.parseContactPreferencesByAccountArrayOptions(this.props),
                srgStatus: 'not-started',
                srgPrevStatus: 'not-started',
                pofStatus: 'not-checked',
                pofPrevStatus: 'not-checked',
            },
        };

        this.handleAffordabilityStatus = this.handleAffordabilityStatus.bind(this);

        this.sdkStaff = props.sdkStaff;
        this.trpcClient = props.common.trpcClient;
    }

    private parseArrayOptions(setting: string, props: CustomerSettingsFormPropsType): Record<string, boolean> {
        const { data } = this.state;
        //@ts-expect-error
        return [].concat(props.data[setting]).reduce((acc, key) => {
            //@ts-expect-error
            acc[`${setting}.${key}`] = data.hasOwnProperty(`${setting}.${key}`) ? data[`${setting}.${key}`] : true;
            return acc;
        }, {});
    }

    private parseContactPreferencesByAccountArrayOptions(
        props: CustomerSettingsFormPropsType
    ): Record<string, boolean> {
        const pre = props.data.contactPreferencesByCategory?.reduce(
            (acc: Record<string, boolean>, { type, categories }: { type: string; categories: string[] }) => {
                categories.forEach((category: string) => {
                    const key = `contactPreferencesByCategory.${type}.${category}`;
                    acc[key] = true;
                });
                return acc;
            },
            {}
        );

        return pre ?? {};
    }

    private async onSrgStatusRequest(): Promise<void> {
        try {
            const timestamp = new Date();
            const response = await this.sdkStaff.setSrgStatus({
                requestBody: {
                    accountId: this.props.data.id.toString(),
                    source: 'backOffice',
                    //@ts-expect-error
                    srgStatus: this.state.data.srgStatus,
                    timestamp: timestamp.toISOString(),
                },
            });

            if (response.message === 'Success') {
                this.setState({ data: { ...this.state.data, srgPrevStatus: this.state.data.srgStatus } });
                return;
            }

            this.setState({ data: { ...this.state.data, srgStatus: this.state.data.srgPrevStatus } });
        } catch (e) {
            console.error(e);
        }
    }

    private async onPofStatusRequest(): Promise<void> {
        try {
            const timestamp = new Date();
            const response = await this.sdkStaff.setPofStatus({
                requestBody: {
                    accountId: this.props.data.id.toString(),
                    source: 'backOffice',
                    reason: 'manual trigger',
                    //@ts-expect-error
                    pofStatus: this.state.data.pofStatus,
                    timestamp: timestamp.toISOString(),
                },
            });

            if (response.message === 'Success') {
                this.setState({ data: { ...this.state.data, pofPrevStatus: this.state.data.pofStatus } });
                return;
            }

            this.setState({ data: { ...this.state.data, pofStatus: this.state.data.pofPrevStatus } });
        } catch (e) {
            console.error(e);
        }
    }

    private async onAffordabilityStatusRequest(): Promise<void> {
        try {
            const resp = await this.sdkStaff.postAffordabilityStatus({
                requestBody: { resultColor: this.state.affordabilityStatus, customerId: this.props.data.id },
            });
            this.setState({
                affordabilityStatus: resp.affordabilityColor,
                affordabilityPrevStatus: resp.affordabilityColor,
            });

            if (
                resp.affordabilityColor === 'Red' ||
                resp.affordabilityColor === 'Amber' ||
                resp.affordabilityColor === 'Green'
            ) {
                this.setState({ affordabilityChecked: true });
            }
        } catch (error) {
            console.error(error);
        }
    }

    private async getPofWalletAggregate(accountId: number): Promise<{ totalNetLoss: number; totalDeposit: number }> {
        if (this.props.newPofSrg === false) {
            const response = await this.trpcClient.client.accountData.getPofWalletAggregate.query({
                accountId: accountId,
            });
            if (response.responseStatus === 'success') {
                return {
                    totalNetLoss: this.pofTotalNetLoss(response.data.totalNetLoss),
                    totalDeposit: parseFloat(response.data.totalDeposit),
                };
            }
        }

        return {
            totalNetLoss: 0,
            totalDeposit: 0,
        };
    }

    //this does not show for new pofsrg and this is expected
    private comparePofLimitState({
        pofWalletAggregate,
        reviewNetLosses,
        reviewTotalDeposits,
        prevReviewNetLosses,
        prevReviewTotalDeposits,
    }: {
        pofWalletAggregate: { totalNetLoss: number; totalDeposit: number };
        reviewNetLosses: number;
        reviewTotalDeposits: number;
        prevReviewNetLosses: number;
        prevReviewTotalDeposits: number;
    }): { needNextReviewUpdate: boolean; errorMessageSuffix: string | null } {
        if (
            pofWalletAggregate.totalDeposit > reviewTotalDeposits &&
            pofWalletAggregate.totalNetLoss > reviewNetLosses
        ) {
            return {
                needNextReviewUpdate: true,
                errorMessageSuffix: "the 'Next review - net losses' and the 'Next review - total deposits' limits",
            };
        } else if (prevReviewNetLosses === reviewNetLosses && prevReviewTotalDeposits === reviewTotalDeposits) {
            //Assumption: When changing status to 'passed', at least one of the 'Next Review (total loss/total deposits)' should also be updated.
            return {
                needNextReviewUpdate: true,
                errorMessageSuffix: "the 'Next review - net losses' or the 'Next review - total deposits' limits",
            };
        } else if (pofWalletAggregate.totalNetLoss > reviewNetLosses) {
            return {
                needNextReviewUpdate: true,
                errorMessageSuffix: "the 'Next review - net losses' limit",
            };
        } else if (pofWalletAggregate.totalDeposit > reviewTotalDeposits) {
            return {
                needNextReviewUpdate: true,
                errorMessageSuffix: "the 'Next review - total deposits' limit",
            };
        } else {
            return {
                needNextReviewUpdate: false,
                errorMessageSuffix: null,
            };
        }
    }

    private checkPofLimitOnly({
        pofWalletAggregate,
        reviewNetLosses,
        reviewTotalDeposits,
        prevReviewNetLosses,
        prevReviewTotalDeposits,
    }: {
        pofWalletAggregate: { totalNetLoss: number; totalDeposit: number };
        reviewNetLosses: number;
        reviewTotalDeposits: number;
        prevReviewNetLosses: number;
        prevReviewTotalDeposits: number;
    }): { needNextReviewUpdate: boolean; errorMessageField: string | null; errorMessageReason: string | null } {
        if (
            prevReviewTotalDeposits !== 0 &&
            prevReviewTotalDeposits !== reviewTotalDeposits &&
            pofWalletAggregate.totalDeposit >= reviewTotalDeposits
        ) {
            return {
                needNextReviewUpdate: true,
                errorMessageField: "'Next review - total deposits'",
                errorMessageReason: "'POF t. deposits'",
            };
        } else if (
            prevReviewNetLosses !== 0 &&
            prevReviewNetLosses !== reviewNetLosses &&
            pofWalletAggregate.totalNetLoss >= reviewNetLosses
        ) {
            return {
                needNextReviewUpdate: true,
                errorMessageField: "'Next review - net losses'",
                errorMessageReason: "'POF net losses'",
            };
        }
        return {
            needNextReviewUpdate: false,
            errorMessageField: null,
            errorMessageReason: null,
        };
    }

    private pofTotalNetLoss(totalNetLoss: string): number {
        return -1 * parseFloat(totalNetLoss);
    }

    private async changeNewContactPreferences(): Promise<void> {
        try {
            const contactPreferenceByCategory = this.props.contactPreferences.preferences
                .map((type) => ({
                    type,
                    categories: this.props.contactPreferences.options.reduce(
                        (prev, option) =>
                            //@ts-expect-error
                            this.state.data[`contactPreferencesByCategory.${type}.${option}`] === true
                                ? [...prev, option]
                                : prev,
                        []
                    ),
                }))
                .filter((item) => item.categories.length > 0);

            await this.trpcClient.client.accountData.changeAccountContactPreferencesNew.mutate({
                customerId: this.props.data.id,
                //@ts-expect-error
                contactPreferences: contactPreferenceByCategory,
            });
        } catch (e) {
            console.error(e);
        }
    }

    public async onSubmit(e: React.FormEvent): Promise<void> {
        e.preventDefault();

        const hasAffordabilityStatusStatusChanged =
            this.state.affordabilityStatus !== this.state.affordabilityPrevStatus;

        if (this.props.isAffordability === true && hasAffordabilityStatusStatusChanged) {
            await this.onAffordabilityStatusRequest();
        }

        if (this.props.contactPreferences.newMarketing) {
            await this.changeNewContactPreferences();
        }

        const hasSrgStatusChanged = this.state.data.srgStatus !== this.state.data.srgPrevStatus;
        const hasPofStatusChanged = this.state.data.pofStatus !== this.state.data.pofPrevStatus;

        if (this.props.isSrg === true && hasSrgStatusChanged) {
            await this.onSrgStatusRequest();
        }

        if (this.props.pofFlag === true) {
            const reviewNetLosses =
                this.state.data.reviewNetLosses === null || this.state.data.reviewNetLosses === undefined
                    ? 0
                    : parseInt(String(this.state.data.reviewNetLosses));
            const reviewTotalDeposits =
                this.state.data.reviewTotalDeposits === null || this.state.data.reviewTotalDeposits === undefined
                    ? 50000
                    : parseInt(String(this.state.data.reviewTotalDeposits));
            const prevReviewNetLosses = this.state.data.prevReviewNetLosses ?? 0;
            const prevReviewTotalDeposits = this.state.data.prevReviewTotalDeposits ?? 50000;
            const pofWalletAggregate = await this.getPofWalletAggregate(this.state.data.id);

            if (hasPofStatusChanged && this.state.data.pofStatus !== 'passed') {
                await this.onPofStatusRequest();
            } else if (hasPofStatusChanged && this.state.data.pofStatus === 'passed') {
                const { needNextReviewUpdate, errorMessageSuffix } = this.comparePofLimitState({
                    pofWalletAggregate,
                    reviewNetLosses,
                    reviewTotalDeposits,
                    prevReviewNetLosses,
                    prevReviewTotalDeposits,
                });

                if (needNextReviewUpdate && this.props.newPofSrg === false) {
                    addError(`Before changing 'POF Status' to 'Passed', please update ${errorMessageSuffix}`);
                    return;
                } else {
                    await this.onPofStatusRequest();
                }
            } else {
                const { needNextReviewUpdate, errorMessageField, errorMessageReason } = this.checkPofLimitOnly({
                    pofWalletAggregate,
                    reviewNetLosses,
                    reviewTotalDeposits,
                    prevReviewNetLosses,
                    prevReviewTotalDeposits,
                });
                if (needNextReviewUpdate) {
                    addError(
                        `${errorMessageField} has to be higher than actual ${errorMessageReason}. Please increase the limit for the ${errorMessageField}`
                    );
                    return;
                }
            }

            this.setState({
                data: {
                    ...this.state.data,
                    prevReviewNetLosses: reviewNetLosses,
                    prevReviewTotalDeposits: reviewTotalDeposits,
                },
            });
        }
        Form.prototype.onSubmit.call(this, e);
    }

    public handleAffordabilityStatus(e: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({ affordabilityStatus: e.target.value });
    }

    public handleAffordabilityManualCheck = async (): Promise<void> => {
        try {
            const resp = await this.sdkStaff.postAffordabilityManualCheck({ user_id: this.props.data.id });
            this.setState({
                affordabilityStatus: resp.affordabilityColor,
                affordabilityPrevStatus: resp.affordabilityColor,
            });
            if (
                resp.affordabilityColor === 'Red' ||
                resp.affordabilityColor === 'Amber' ||
                resp.affordabilityColor === 'Green'
            ) {
                this.setState({ affordabilityChecked: true });
            }

            this.setState({ affordabilityManualCheckMessage: true });
        } catch (error) {
            this.setState({ affordabilityManualCheckMessage: false });
            console.error(error);
        }
    };

    public handleIdMissionStatus = async (e: React.ChangeEvent<HTMLSelectElement>): Promise<void> => {
        this.setState({
            previousIdMissionStatus: this.state.idMissionStatus,
            idMissionStatus: e.target.value,
        });
    };

    public handleCopyPasswordToken = async (): Promise<void> => {
        const token = this.props.data.passwordResetToken?.token;
        if (token !== undefined) {
            try {
                await navigator.clipboard.writeText(token);
                this.setState({ passwordTokenCopied: true });
                setTimeout(() => {
                    this.setState({ passwordTokenCopied: false });
                }, 2000);
            } catch (error) {
                console.error('Failed to copy token:', error);
            }
        }
    };

    public handleManualTriggerIdMission = async (): Promise<void> => {
        this.setState({ idMissionActionResponse: IdMissionResponseType.NONE });
        const { gatewayUrl } = this.props.common.appEnvParams;

        if (this.state.idMissionStatus === null || this.state.idMissionStatus === '') {
            this.setState({ idMissionActionResponse: IdMissionResponseType.TRIGGER_ERROR });
            return;
        }

        if (this.state.previousIdMissionStatus !== null && this.state.previousIdMissionStatus !== '') {
            try {
                await confirmation('Do you want to proceed with manually changing the ID Mission trigger?', true);
            } catch (error) {
                return;
            }
        }

        const verificationVariant = this.state.idMissionStatus;

        try {
            const body = {
                accountId: this.props.data.id,
                universe: this.props.universe,
                verificationVariant,
                triggerReason: 'manual',
            };

            const response = await apiManualTriggerRequest(
                gatewayUrl,
                { requestBody: body },
                { authorization: `Bearer ${this.props.common.session.currentJwt}` }
            );

            if (response.status === 200) {
                this.setState({
                    idMissionActionResponse: IdMissionResponseType.TRIGGER_SUCCESS,
                    initialIdMissionStatus: this.state.idMissionStatus,
                });
            } else {
                this.setState({
                    idMissionActionResponse: IdMissionResponseType.TRIGGER_ERROR,
                    idMissionStatus: this.state.initialIdMissionStatus,
                });
            }
        } catch (error) {
            this.setState({
                idMissionActionResponse: IdMissionResponseType.TRIGGER_ERROR,
                idMissionStatus: this.state.initialIdMissionStatus,
            });
            console.error(error);
        }
    };

    public handleCancelManualTrigger = async (): Promise<void> => {
        this.setState({ idMissionActionResponse: IdMissionResponseType.NONE });
        const { gatewayUrl } = this.props.common.appEnvParams;

        try {
            await confirmation('Do you want to proceed with canceling manual ID Mission trigger?', true);
        } catch (error) {
            return;
        }

        try {
            const verificationsResponse = await apiVerificationsRequest(
                gatewayUrl,
                { account_id: this.props.data.id, latest_only: true },
                { authorization: `Bearer ${this.props.common.session.currentJwt}` }
            );

            if (verificationsResponse.status === 200 && verificationsResponse.body[0] !== undefined) {
                const latestVerification = verificationsResponse.body[0];
                const verificationId = latestVerification.verification.id;

                const cancelResponse = await apiCancelTriggerRequest(
                    gatewayUrl,
                    {
                        verification_id: verificationId,
                        requestBody: {
                            accountId: this.props.data.id,
                        },
                    },
                    { authorization: `Bearer ${this.props.common.session.currentJwt}` }
                );

                if (cancelResponse.status === 200) {
                    this.setState({
                        idMissionActionResponse: IdMissionResponseType.CANCEL_SUCCESS,
                        idMissionStatus: null,
                        previousIdMissionStatus: null,
                        initialIdMissionStatus: null,
                    });
                } else {
                    this.setState({
                        idMissionActionResponse: IdMissionResponseType.CANCEL_ERROR,
                    });
                }
            } else {
                this.setState({
                    idMissionActionResponse: IdMissionResponseType.CANCEL_ERROR,
                });
            }
        } catch (error) {
            this.setState({
                idMissionActionResponse: IdMissionResponseType.CANCEL_ERROR,
            });
            console.error('Error canceling ID Mission:', error);
        }
    };

    public getStatuses = async (
        sdkStaff: SdkStaff,
        userId: number
    ): Promise<{ srgStatus: string; pofStatus: string }> => {
        try {
            const customerDataResponse = await sdkStaff.getBasicData(userId);
            return {
                srgStatus: customerDataResponse.srgStatus ?? 'not-started',
                pofStatus: customerDataResponse.pofStatus ?? 'not-checked',
            };
        } catch (error) {
            console.error(error);
            return {
                srgStatus: 'not-started',
                pofStatus: 'not-checked',
            };
        }
    };

    public getAffordabilityStatus = async (sdkStaff: SdkStaff, userId: number): Promise<void> => {
        try {
            const resp = await sdkStaff.getAffordabilityStatus(userId);
            this.setState({
                affordabilityStatus: resp.affordabilityColor,
                affordabilityPrevStatus: resp.affordabilityColor,
            });

            if (
                resp.affordabilityColor === 'Red' ||
                resp.affordabilityColor === 'Amber' ||
                resp.affordabilityColor === 'Green'
            ) {
                this.setState({ affordabilityChecked: true });
            } else {
                this.setState({ affordabilityChecked: false });
            }
        } catch (error) {
            console.error(error);
        }
    };

    public getIdMissionStatus = async (accountId: number): Promise<void> => {
        try {
            const { gatewayUrl } = this.props.common.appEnvParams;
            const response = await apiVerifyProgressRequest(
                gatewayUrl,
                { account_id: accountId },
                { authorization: `Bearer ${this.props.common.session.currentJwt}` }
            );

            if (response.status === 200) {
                this.setState({
                    idMissionStatus: response.body.verificationVariant,
                    previousIdMissionStatus: response.body.verificationVariant,
                    initialIdMissionStatus: response.body.verificationVariant,
                });
            }
        } catch (error) {
            console.error('Error fetching ID Mission status:', error);
        }
    };

    public getVisibility(name: string): { display: string } | {} {
        //@ts-expect-error
        const val = this.state.data[name]
            ? //@ts-expect-error
              this.state.data[name].hasOwnProperty('hidden')
                ? //@ts-expect-error
                  this.state.data[name].hidden
                : false
            : false;
        return val ? { display: 'none' } : {};
    }

    public openSportsStakes(): void {
        this.props.openSportsStakes();
    }

    public _onChange(field: string, value: string | boolean | null): void {
        const { data } = this.state;

        if (field === 'betReferralEnabled' && !value && has(this.state.data, 'quickBetReferralEnabled.value')) {
            //@ts-expect-error
            this.state.data['quickBetReferralEnabled'].value = false;
        }
        Form.prototype._onChange.call(this, field, value, data);
    }

    public async componentDidMount(): Promise<void> {
        if (this.props.isAffordability === true) {
            await this.getAffordabilityStatus(this.props.sdkStaff, this.props.data.id);
        }

        if (this.props.isSrg === true || this.props.pofFlag === true) {
            const { srgStatus, pofStatus } = await this.getStatuses(this.props.sdkStaff, this.props.data.id);
            this.setState({
                data: {
                    ...this.state.data,
                    srgStatus,
                    srgPrevStatus: srgStatus,
                    pofStatus,
                    pofPrevStatus: pofStatus,
                    prevReviewNetLosses: this.props.data.reviewNetLosses,
                    prevReviewTotalDeposits: this.props.data.reviewTotalDeposits,
                },
            });
        }

        if (this.props.idMission === true) {
            await this.getIdMissionStatus(this.props.data.id);
        }
    }

    public getValue(name: string): string | boolean | Date {
        //@ts-expect-error
        return this.state.data[name] && this.state.data[name].hasOwnProperty('value')
            ? //@ts-expect-error
              this.state.data[name].value
            : false;
    }

    public renderForm(): JSX.Element {
        const {
            errors,
            stakesCount,
            isAffordability,
            ringFencedFunds,
            isSrg,
            pofFlag,
            idMission,
            currencies,
            contactPreferences,
            accountTradingTartanClub,
            accountTradingRewardZone,
            accountTradingDragonCircle,
            accountTradingCountryClub,
            closureCodes,
            isPEP,
        } = this.props;
        const { playBreakExpiry, selfExclusionExpiry } = this.props.data;
        const creditAccount =
            this.state.data['creditAccount'] && this.state.data['creditAccount'].hasOwnProperty('value')
                ? this.state.data['creditAccount'].value
                : this.state.data['creditAccount'];
        const betReferralEnabled =
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            get(this.state.data, 'betReferralEnabled.value') || this.state.data['betReferralEnabled'];

        const currenciesList = currencies.map((c) => (
            <option
                key={c}
                value={c}
            >
                {c}
            </option>
        ));

        const arrValueOption = ['active', 'pending', 'suspended', 'blocked', 'closed'];
        const arrOption = [];

        for (const i of arrValueOption) {
            arrOption.push(
                <option
                    key={i}
                    value={i}
                >
                    {i.replace(/\b\w/g, (l) => l.toUpperCase())}
                </option>
            );
        }

        const closureReasonIdArray = Array.from({ length: 30 }, (_, index) => index + 1);
        const closureReasonIdOption = [];

        for (const i of closureReasonIdArray) {
            closureReasonIdOption.push(
                <option
                    key={i}
                    value={i}
                >
                    {i}
                </option>
            );
        }

        const spOnlySports = [
            {
                label: 'SP Only Horse Racing',
                key: 'horseracing',
            },
            {
                label: 'SP Only International Horse Racing',
                key: 'internationalhorseracing',
            },
            {
                label: 'SP Only Greyhound Racing',
                key: 'greyhoundracing',
            },
        ];

        const playBreakOrSelfExcluded = !hasExpired(playBreakExpiry) || !hasExpired(selfExclusionExpiry);

        return (
            <div className='customer-settings-form'>
                <div className='row'>
                    <div className='col-4'>
                        <h2>Accounting</h2>

                        {this.getField(
                            <select
                                //@ts-expect-error
                                label='Account status'
                                {...this.getFieldParameters('status')}
                            >
                                <option />
                                {arrOption}
                            </select>
                        )}
                        {closureCodes &&
                        //@ts-expect-error
                        (this.state.data.status.value === 'closed' || this.state.data.status === 'closed')
                            ? this.getField(
                                  <select
                                      //@ts-expect-error
                                      label='Closure reason'
                                      {...this.getFieldParameters('closureReasonId')}
                                  >
                                      <option />
                                      {closureReasonIdOption}
                                  </select>
                              )
                            : null}
                        {this.getField(
                            <select
                                //@ts-expect-error
                                label='Currency'
                                {...this.getFieldParameters('currency')}
                            >
                                <option />
                                {currenciesList}
                            </select>
                        )}
                        {this.getCheckbox(
                            'printedStatement',
                            'Statements',
                            null,
                            null,
                            this.getVisibility('printedStatement')
                        )}

                        {this.getField(
                            <select
                                //@ts-expect-error
                                visibility={this.getVisibility('statementFrequency')}
                                label='Statement frequency'
                                {...this.getFieldParameters('statementFrequency')}
                            >
                                <option />
                                <option value='weekly'>Weekly</option>
                                <option value='monthly'>Monthly</option>
                            </select>
                        )}

                        {this.getCheckbox('commission', 'Commission')}

                        {ringFencedFunds === true
                            ? this.getCheckbox(
                                  'ringFencedFunds',
                                  'Confirm customer is aware of ringfenced funds legislation'
                              )
                            : null}

                        {this.getCheckbox('cancelWithdrawal', 'Withdrawal Cancel Enabled')}

                        <ContactPreferencesContainer>
                            <h2>Contact Preferences</h2>
                            {contactPreferences.newMarketing === true ? (
                                <ContactPreferences>
                                    {contactPreferences.preferences.map((contactPreference) => (
                                        <div
                                            key={contactPreference}
                                            data-test={`contact-preferences-${contactPreference}`}
                                        >
                                            <ContactPreferencesHeader>{contactPreference}</ContactPreferencesHeader>
                                            <div>
                                                {contactPreferences.options.map((option) =>
                                                    this.getCheckbox(
                                                        `contactPreferencesByCategory.${contactPreference}.${option}`,
                                                        option,
                                                        option,
                                                        playBreakOrSelfExcluded
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    ))}{' '}
                                </ContactPreferences>
                            ) : (
                                contactPreferences.preferences.map((contactPreference) =>
                                    this.getCheckbox(
                                        `contactPreferences.${contactPreference}`,
                                        contactPreference,
                                        contactPreference,
                                        playBreakOrSelfExcluded
                                    )
                                )
                            )}
                        </ContactPreferencesContainer>

                        <h2>Registration - Sign Up Code</h2>

                        {this.getField(
                            <input
                                type='text'
                                //@ts-expect-error
                                label='Registration Promo ID'
                                {...this.getFieldParameters('promoID')}
                            />
                        )}

                        {this.getField(
                            <input
                                type='text'
                                //@ts-expect-error
                                label='AffiliateID'
                                {...this.getFieldParameters('incomeaccess')}
                            />
                        )}

                        <div className='element'>
                            <div className='flex gap-2 items-center'>
                                <div className='relative flex-1'>
                                    <input
                                        type='text'
                                        readOnly
                                        value={this.props.data.passwordResetToken?.token || ''}
                                        className='!bg-gray-100 cursor-not-allowed w-full truncate pr-6 !pt-3 !pb-1'
                                        data-test='password-reset-token-input'
                                        disabled
                                    />
                                    <div className='absolute right-2 top-1/2 transform -translate-y-1/2'>
                                        <IndependentTooltip
                                            content={
                                                <>
                                                    This is a password reset token
                                                    <br />
                                                    used to build requests for
                                                    <br />
                                                    resetting user passwords
                                                </>
                                            }
                                        >
                                            <span className='inline-block w-4 h-4 rounded-full bg-transparent text-black text-center text-xs leading-4 cursor-help border border-black ring-1 ring-black'>
                                                ?
                                            </span>
                                        </IndependentTooltip>
                                    </div>
                                </div>
                                <button
                                    type='button'
                                    onClick={this.handleCopyPasswordToken}
                                    className='btn btn-sm btn-outline-secondary'
                                    disabled={!this.props.data.passwordResetToken?.token}
                                >
                                    Copy
                                </button>
                            </div>
                            <label>Password Reset Token</label>
                            {this.state.passwordTokenCopied && <SuccessMessage size='small'>Copied!</SuccessMessage>}
                        </div>
                    </div>

                    <div className='col-4'>
                        <h2>Trading</h2>

                        {this.getField(
                            <textarea
                                className='notes'
                                //@ts-expect-error
                                label='Trading notes'
                                {...this.getFieldParameters('tradingNotes')}
                            />
                        )}
                        <div className='row'>
                            <div className='col-4'>
                                {this.getField(
                                    <input
                                        type='text'
                                        //@ts-expect-error
                                        label='Pre Match SF'
                                        {...this.getFieldParameters('stakeFactor')}
                                    />
                                )}
                            </div>
                            <div className='col-4'>
                                {this.getField(
                                    <input
                                        type='text'
                                        //@ts-expect-error
                                        label='Show/In Play SF'
                                        {...this.getFieldParameters('stakeFactorInPlay')}
                                    />
                                )}
                            </div>
                            <div className='col-4'>
                                <button
                                    className='btn btn-primary btn-large'
                                    type='button'
                                    onClick={this.openSportsStakes.bind(this)}
                                    data-test='set-sport-sf-button'
                                >
                                    {stakesCount.prematch > 0 || stakesCount.inplay > 0
                                        ? `${stakesCount.prematch}/${stakesCount.inplay} `
                                        : 'Set '}
                                    Sport SF
                                </button>
                            </div>
                        </div>

                        {this.getCheckbox('creditAccount', 'Credit account')}

                        {this.getField(
                            <input
                                type='text'
                                //@ts-expect-error
                                label='Credit limit'
                                disabled={!creditAccount}
                                {...this.getFieldParameters('creditLimit')}
                            />
                        )}

                        {this.getField(
                            <select
                                //@ts-expect-error
                                visibility={this.getVisibility('creditPaymentTerms')}
                                label='Credit payment terms'
                                disabled={!creditAccount}
                                {...this.getFieldParameters('creditPaymentTerms')}
                            >
                                <option />
                                <option value='weekly-auto-payment'>WAP (Weekly Auto Payment)</option>
                                <option value='monthly-statement'>MS (Monthly Statement)</option>
                                <option value='cheque'>Cheque</option>
                                <option value='bacs'>BACS</option>
                            </select>
                        )}

                        {this.getCheckbox('betReferralEnabled', 'Bet Referrals Enabled')}
                        {this.getCheckbox('isHVC', 'HVC stake boost %', 'isHVC', null, this.getVisibility('isHVC'))}
                        {this.getCheckbox('cashoutEnabled', 'Cash out')}

                        {this.getCheckbox('bpEnabled', 'Best Odds Guaranteed')}
                        {this.state.data.bpEnabled
                            ? this.getField(
                                  <input
                                      type='text'
                                      //@ts-expect-error
                                      label='BOG Max Payout'
                                      {...this.getFieldParameters('bogLimit')}
                                  />
                              )
                            : null}
                        {this.getCheckbox(
                            'quickBetReferralEnabled',
                            'Quick Bet referral',
                            'quickBetReferralEnabled',
                            !betReferralEnabled,
                            this.getVisibility('quickBetReferralEnabled')
                        )}
                        {this.getCheckbox('promoBanned', 'Promo Banned')}
                        {spOnlySports.map(({ label, key }) => this.getCheckbox(`spOnly-${key}`, label, key))}

                        {accountTradingTartanClub === true
                            ? this.getCheckbox('tartanClub', 'Tartan Club', 'tartanClub', null, {})
                            : null}

                        {accountTradingRewardZone === true
                            ? this.getCheckbox('rewardZone', 'Reward Zone', 'rewardZone', null, {})
                            : null}

                        {accountTradingDragonCircle === true
                            ? this.getCheckbox('dragonCircle', 'Dragon Circle', 'dragonCircle', null, {})
                            : null}
                        {accountTradingCountryClub === true
                            ? this.getCheckbox('countryClub', 'Country Club', 'countryClub', null, {})
                            : null}
                        {this.getCheckbox('chatEnabled', 'Trader Chat')}
                    </div>

                    <div className='col-4'>
                        <h2>Security</h2>

                        {this.getField(
                            <textarea
                                className='notes'
                                //@ts-expect-error
                                label='Security notes'
                                {...this.getFieldParameters('securityNotes')}
                            />
                        )}
                        {isPEP ? this.getCheckbox('pep', 'PEP') : null}
                        {isPEP ? this.getCheckbox('sanctions', 'Sanctions') : null}
                        {this.getField(
                            <select
                                //@ts-expect-error
                                visibility={this.getVisibility('ageVerification')}
                                label='Age Verification'
                                {...this.getFieldParameters('ageVerification')}
                            >
                                <option />
                                <option value='not-checked'>Not Checked</option>
                                <option value='passed'>Passed</option>
                                <option value='failed'>Failed</option>
                                <option value='unknown'>Unknown</option>
                            </select>
                        )}

                        {this.getField(
                            <select
                                //@ts-expect-error
                                visibility={this.getVisibility('kycStatus')}
                                label='KYC status'
                                {...this.getFieldParameters('kycStatus')}
                            >
                                <option />
                                <option value='passed'>Passed</option>
                                <option value='failed'>Failed</option>
                                <option value='not-checked'>Not checked</option>
                                <option value='required'>Required</option>
                                <option value='requested'>Requested</option>
                                <option value='no-id-received'>No ID Received</option>
                            </select>
                        )}

                        {this.getField(
                            <select
                                //@ts-expect-error
                                visibility={this.getVisibility('amlRisk')}
                                label='AML Risk'
                                {...this.getFieldParameters('amlRisk')}
                            >
                                <option />
                                <option value='high'>High</option>
                                <option value='medium-high'>Medium/High</option>
                                <option value='medium-low'>Medium/Low</option>
                                <option value='low'>Low</option>
                            </select>
                        )}

                        {isAffordability === true ? (
                            <>
                                {this.getField(
                                    <SelectWithPadding
                                        value={this.state.affordabilityStatus}
                                        onChange={this.handleAffordabilityStatus}
                                        //@ts-expect-error
                                        label='TU affordability'
                                    >
                                        <option />
                                        {this.state.affordabilityChecked === true ? null : (
                                            <option value='Unknown'>Not Checked</option>
                                        )}
                                        <option value='Red'>Red</option>
                                        <option value='Amber'>Amber</option>
                                        <option value='Green'>Green</option>
                                    </SelectWithPadding>
                                )}
                                <CustomerSettingsDiv>
                                    <CustomerSettingsButton
                                        type='button'
                                        onClick={this.handleAffordabilityManualCheck}
                                        data-test='manual-check-of-affordability-status-button'
                                    >
                                        Manual Check of Affordability Status
                                    </CustomerSettingsButton>
                                </CustomerSettingsDiv>
                            </>
                        ) : null}

                        {this.state.affordabilityManualCheckMessage === true ? (
                            <SuccessMessage data-test='manual-affordability-check-result-message'>
                                Manual affordability status check: success
                            </SuccessMessage>
                        ) : null}
                        {this.state.affordabilityManualCheckMessage === false ? (
                            <ErrorMessage data-test='manual-affordability-check-result-message'>
                                Manual affordability status check: failure{' '}
                            </ErrorMessage>
                        ) : null}

                        {idMission === true ? (
                            <>
                                {this.getField(
                                    <SelectWithPadding
                                        value={this.state.idMissionStatus || ''}
                                        onChange={this.handleIdMissionStatus}
                                        //@ts-expect-error
                                        label='ID Mission'
                                    >
                                        <option value=''>Select option</option>
                                        <option value='IdCard'>Id Card</option>
                                        <option value='IdCardProofOfAddress'>Id Card and Proof Of Address</option>
                                        <option value='IdCardAndFace'>Id Card and Face</option>
                                        <option value='IdCardAndFaceProofOfAddress'>
                                            Id Card and Face and Proof Of Address
                                        </option>
                                    </SelectWithPadding>
                                )}
                                <CustomerSettingsDiv>
                                    <CustomerSettingsButton
                                        type='button'
                                        onClick={
                                            this.state.idMissionStatus === null ||
                                            this.state.idMissionStatus === '' ||
                                            this.state.idMissionStatus !== this.state.initialIdMissionStatus
                                                ? this.handleManualTriggerIdMission
                                                : this.handleCancelManualTrigger
                                        }
                                        disabled={
                                            this.state.idMissionStatus === null || this.state.idMissionStatus === ''
                                        }
                                        data-test='manual-id-mission-status-button'
                                    >
                                        {this.state.idMissionStatus === null ||
                                        this.state.idMissionStatus === '' ||
                                        this.state.idMissionStatus !== this.state.initialIdMissionStatus
                                            ? 'Manual Trigger of ID Mission'
                                            : 'Cancel Manual Trigger of ID Mission'}
                                    </CustomerSettingsButton>
                                </CustomerSettingsDiv>
                            </>
                        ) : null}

                        {this.state.idMissionActionResponse === IdMissionResponseType.TRIGGER_SUCCESS ? (
                            <SuccessMessage data-test='manual-id-mission-check-result-message'>
                                ID mission triggered successfully
                            </SuccessMessage>
                        ) : null}
                        {this.state.idMissionActionResponse === IdMissionResponseType.TRIGGER_ERROR ? (
                            <ErrorMessage data-test='manual-id-mission-check-result-message'>
                                Trigger ID mission has failed
                            </ErrorMessage>
                        ) : null}
                        {this.state.idMissionActionResponse === IdMissionResponseType.CANCEL_SUCCESS ? (
                            <SuccessMessage data-test='manual-id-mission-check-result-message'>
                                Manual trigger canceled
                            </SuccessMessage>
                        ) : null}
                        {this.state.idMissionActionResponse === IdMissionResponseType.CANCEL_ERROR ? (
                            <ErrorMessage data-test='manual-id-mission-check-result-message'>
                                Cancelling manual trigger has failed
                            </ErrorMessage>
                        ) : null}

                        {pofFlag === true
                            ? this.getField(
                                  <select
                                      //@ts-expect-error
                                      visibility={this.getVisibility('pofStatus')}
                                      label='POF Status'
                                      {...this.getFieldParameters('pofStatus')}
                                  >
                                      <option />
                                      <option value='not-checked'>Not checked</option>
                                      <option value='passed'>Passed</option>
                                      <option value='failed'>Failed</option>
                                      <option value='requested'>Requested</option>
                                  </select>
                              )
                            : null}
                        {isSrg === true
                            ? this.getField(
                                  <select
                                      //@ts-expect-error
                                      visibility={this.getVisibility('srgStatus')}
                                      label='SRG Status'
                                      {...this.getFieldParameters('srgStatus')}
                                  >
                                      <option />
                                      <option value='not-started'>Not Started</option>
                                      <option value='passed'>Passed</option>
                                      <option value='failed'>Failed</option>
                                      <option value='requested'>Requested</option>
                                  </select>
                              )
                            : null}

                        {this.getField(
                            <input
                                type='text'
                                //@ts-expect-error
                                visibility={this.getVisibility('failedLoginAttempts')}
                                disabled={true}
                                label='Failed login attempts'
                                {...this.getFieldParameters('failedLoginAttempts')}
                            />
                        )}
                        {this.props.sourceOfFunds === true ? (
                            <>
                                {this.getField(
                                    <input
                                        type='text'
                                        //@ts-expect-error
                                        visibility={this.getVisibility('reviewTotalDeposits')}
                                        disabled={false}
                                        label='Next review - total deposits'
                                        placeholder='Not set'
                                        {...this.getFieldParameters('reviewTotalDeposits')}
                                    />
                                )}
                                {this.props.newPofSrg === true ? null : (
                                    <>
                                        {this.getField(
                                            <input
                                                type='text'
                                                //@ts-expect-error
                                                visibility={this.getVisibility('reviewNetLosses')}
                                                disabled={false}
                                                label='Next review - net losses'
                                                placeholder='Not set'
                                                {...this.getFieldParameters('reviewNetLosses')}
                                            />
                                        )}
                                    </>
                                )}
                                {this.getField(
                                    <DateInput
                                        label='Next review date'
                                        disabled={false}
                                        selected={
                                            this.getValue('nextReviewDate')
                                                ? //@ts-expect-error
                                                  new Date(this.getValue('nextReviewDate'))
                                                : null
                                        }
                                        placeholderText='Not set'
                                        withRemoveButton={true}
                                        {...this.getFieldParameters('nextReviewDate')}
                                    />
                                )}
                            </>
                        ) : null}
                    </div>
                </div>

                {this.getBasicError(errors.get && errors.get('program'))}

                <div className='buttons'>
                    <button
                        className='btn btn-primary'
                        type='submit'
                    >
                        Update account
                    </button>
                </div>
            </div>
        );
    }
}

export const CustomerSettingsForm = observer('CustomerSettingsForm', (props: CustomerSettingsFormPropsType) => {
    const { sdkStaff } = useAppStateContext();
    const common = useCommon();
    const {
        universe,
        config: {
            showRingFencedFunds,
            isAffordability,
            sourceOfFunds,
            srgEnabled,
            idMission,
            newPofSrg,
            currencies,
            contactPreferences,
            accountTradingTartanClub,
            accountTradingRewardZone,
            accountTradingDragonCircle,
            accountTradingCountryClub,
            closureCodes,
            isPEP,
            pof,
            complianceNew,
        },
    } = ConfigState.get(common);

    const { data, errors, onSubmit, openSportsStakes, stakesCount, languages } = props;

    const [exclusionStore] = React.useState(() => {
        if (!complianceNew) return null;
        const store = new ReactivateSelfExclusionStore(common, data.id, sdkStaff);
        void store.fetchSelfExclusionStatus();
        return store;
    });

    const effectiveData =
        complianceNew && exclusionStore !== null
            ? { ...data, selfExclusionExpiry: exclusionStore.exclusionStatus?.reactivationAllowedAfter ?? null }
            : data;

    return (
        <CustomerSettingsFormInner
            common={common}
            data={effectiveData}
            errors={errors}
            onSubmit={onSubmit}
            openSportsStakes={openSportsStakes}
            stakesCount={stakesCount}
            universe={universe}
            languages={languages}
            sdkStaff={sdkStaff}
            isAffordability={isAffordability}
            pofFlag={pof}
            isSrg={srgEnabled}
            idMission={idMission}
            ringFencedFunds={showRingFencedFunds}
            sourceOfFunds={sourceOfFunds}
            currencies={currencies}
            contactPreferences={contactPreferences}
            accountTradingTartanClub={accountTradingTartanClub}
            accountTradingRewardZone={accountTradingRewardZone}
            accountTradingDragonCircle={accountTradingDragonCircle}
            accountTradingCountryClub={accountTradingCountryClub}
            closureCodes={closureCodes}
            isPEP={isPEP}
            newPofSrg={newPofSrg}
        />
    );
});
